import React from 'react';
import PropTypes from 'prop-types';

const SrSuggestedSearchRemove = ({ displayName, removeSuggestedFilter }) => (
  <div className="suggestedSearchRemoveContainer" onClick={removeSuggestedFilter}>
    <span className="suggestedSearchContent">
      {`${displayName} - `}
      <span className="suggestedSearchRemove">&nbsp;remove</span>
    </span>
  </div>
);

SrSuggestedSearchRemove.propTypes = {
  displayName: PropTypes.string.isRequired,
  removeSuggestedFilter: PropTypes.func.isRequired,
};

SrSuggestedSearchRemove.displayName = 'SrSuggestedSearchRemove';

export default SrSuggestedSearchRemove;
